<div class="spacing--margin-top">
  <agr-summary-card
    [title]="'feed-profit.detail.baseline.feedtables-title' | translate"
    [canExpand]="false"
  >
    <app-baseline-table
      feederType="Start"
      [feederRows]="startFeederRows"
      [products]="products$ | async"
      [discounts]="discounts$ | async"
      [isExtendedSimulation]="isExtendedSimulation"
      (feederPropertiesChanged)="propegateNewFeederValues($event)"
    ></app-baseline-table>
    <app-baseline-table
      feederType="Growth"
      [feederRows]="growthFeederRows"
      [products]="products$ | async"
      [discounts]="discounts$ | async"
      [isExtendedSimulation]="isExtendedSimulation"
      (feederPropertiesChanged)="propegateNewFeederValues($event)"
    ></app-baseline-table>
    <app-baseline-table
      feederType="End"
      [feederRows]="endFeederRows"
      [products]="products$ | async"
      [discounts]="discounts$ | async"
      [calculatedEndFeederRows]="calculatedEndFeederRows"
      [isExtendedSimulation]="isExtendedSimulation"
      (feederPropertiesChanged)="propegateNewFeederValues($event)"
      (calculatedFeederPropertiesChanged)="propegateNewCalculatedFeederValues($event)"
    ></app-baseline-table>
  </agr-summary-card>
</div>
